var React = require('react');

function Coupon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5,4 C23.3033233,4 23.9591546,4.6415118 23.9981643,5.44775606 L24,5.52380952 L24,18.4761905 C24,19.2922649 23.3685118,19.9585062 22.5748651,19.9981351 L22.5,20 L7.13072305,20 C6.72928825,20 6.34587971,19.8366121 6.06504513,19.5485695 L6.00646712,19.4849522 L0.375744074,13.0087617 C-0.10735545,12.4531236 -0.124609004,11.6288792 0.32398341,11.0540549 L0.375744074,10.9912383 L6.00646712,4.51504782 C6.2722169,4.20939503 6.64657978,4.02563024 7.04500803,4.00248672 L7.13072305,4 L22.5,4 Z M5.72712179,9.87511368 C4.55357949,9.87511368 3.60223548,10.8264577 3.60223548,12 C3.60223548,13.1735423 4.55357949,14.1248863 5.72712179,14.1248863 C6.9006641,14.1248863 7.85200811,13.1735423 7.85200811,12 C7.85200811,10.8264577 6.9006641,9.87511368 5.72712179,9.87511368 Z","fillRule":"nonzero"}));
}

Coupon.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Coupon;

Coupon.default = Coupon;
